<!-- Vertical Mode (Default) -->
<div *ngIf="displayMode === 'vertical'" class="table-text-m !leading-tight">
  <!-- Pagador -->
  <div *ngIf="useSoldTo" class="flex flex-col">
    <div class="flex items-center gap-x-2" *ngIf="showLabels">
      <strong>Pagador:</strong>
      <span class="table-text-code">
        <app-business-partner-navigation
          [businessPartner]="soldToNavigationData"
          displayMode="code"
          [customQueryParams]="navigationQueryParams"
          [openInNewTab]="openNavigationInNewTab"
          [showIcon]="showNavigationIcon"
          [showText]="true"
          [interactionMode]="navigationInteractionMode"
          [iconPosition]="navigationIconPosition"
          [icon]="customNavigationIcon"
          [customTooltipText]="customNavigationTooltip"
          [customClass]="'table-text-code'"
          (businessPartnerNavigate)="handleSoldToNavigation($event)"
        >
        </app-business-partner-navigation>
      </span>
    </div>
    <div class="flex items-start gap-x-1">
      <mat-icon
        *ngIf="showIcons && customerType && customerTypeIcon"
        [style.color]="customerTypeColor"
        [matTooltip]="customerTypeTooltip"
        class="text-base leading-none mt-0.5"
      >
        {{ customerTypeIcon }}
      </mat-icon>
      <div class="flex flex-col">
        <span>
          {{ soldToName }}
        </span>
      </div>
    </div>
  </div>

  <!-- Receptor -->
  <div *ngIf="useShipTo" class="flex flex-col mt-1">
    <div class="flex items-center gap-x-2" *ngIf="showLabels">
      <strong>Receptor:</strong>

      <span class="table-text-code">
        <app-business-partner-navigation
          [businessPartner]="shipToNavigationData"
          displayMode="code"
          [customQueryParams]="navigationQueryParams"
          [openInNewTab]="openNavigationInNewTab"
          [showIcon]="showNavigationIcon"
          [showText]="true"
          [interactionMode]="navigationInteractionMode"
          [iconPosition]="navigationIconPosition"
          [icon]="customNavigationIcon"
          [customTooltipText]="customNavigationTooltip"
          [customClass]="'table-text-code'"
          (businessPartnerNavigate)="handleShipToNavigation($event)"
        >
        </app-business-partner-navigation>
      </span>
    </div>
    <div class="flex items-start gap-x-1">
      <mat-icon
        *ngIf="showIcons && customerType && customerTypeIcon"
        [style.color]="customerTypeColor"
        [matTooltip]="customerTypeTooltip"
        class="text-base leading-none mt-0.5"
      >
        {{ customerTypeIcon }}
      </mat-icon>
      <div class="flex flex-col">
        <span>
          {{ shipToName }}
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Horizontal Mode -->
<div
  *ngIf="displayMode === 'horizontal'"
  class="table-text-m flex flex-row gap-x-4 !leading-tight"
>
  <!-- Pagador -->
  <div class="flex flex-col flex-1">
    <div class="flex items-center gap-x-2" *ngIf="showLabels">
      <strong>Pagador:</strong>
    </div>
    <div class="flex items-start gap-x-1">
      <mat-icon
        *ngIf="showIcons && customerType && customerTypeIcon"
        [style.color]="customerTypeColor"
        [matTooltip]="customerTypeTooltip"
        class="text-base leading-none mt-0.5"
      >
        {{ customerTypeIcon }}
      </mat-icon>
      <div class="flex flex-col">
        <!-- Pagador with navigation (horizontal) -->
        <div *ngIf="enableNavigation; else soldToPlainHorizontal">
          <app-business-partner-navigation
            [businessPartner]="soldToNavigationData"
            [displayMode]="navigationDisplayMode"
            [customQueryParams]="navigationQueryParams"
            [openInNewTab]="openNavigationInNewTab"
            [showIcon]="showNavigationIcon"
            [showText]="showNavigationText"
            [interactionMode]="navigationInteractionMode"
            [iconPosition]="navigationIconPosition"
            [icon]="customNavigationIcon"
            [customTooltipText]="customNavigationTooltip"
            [customClass]="'table-text-code truncate'"
            (businessPartnerNavigate)="handleSoldToNavigation($event)"
          >
          </app-business-partner-navigation>
        </div>

        <ng-template #soldToPlainHorizontal>
          <span class="table-text-code truncate">
            {{ soldToCode }}
          </span>
          <span class="truncate">
            {{ soldToName }}
          </span>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Separator -->
  <div class="w-px bg-gray-300 dark:bg-gray-600"></div>

  <!-- Receptor -->
  <div class="flex flex-col flex-1">
    <div class="flex items-center gap-x-2" *ngIf="showLabels">
      <strong>Receptor:</strong>
    </div>
    <div class="flex items-start gap-x-1">
      <mat-icon
        *ngIf="showIcons && customerType && customerTypeIcon"
        [style.color]="customerTypeColor"
        [matTooltip]="customerTypeTooltip"
        class="text-base leading-none mt-0.5"
      >
        {{ customerTypeIcon }}
      </mat-icon>
      <div class="flex flex-col">
        <!-- Receptor with navigation (horizontal) -->
        <div *ngIf="enableNavigation; else shipToPlainHorizontal">
          <app-business-partner-navigation
            [businessPartner]="shipToNavigationData"
            [displayMode]="navigationDisplayMode"
            [customQueryParams]="navigationQueryParams"
            [openInNewTab]="openNavigationInNewTab"
            [showIcon]="showNavigationIcon"
            [showText]="showNavigationText"
            [interactionMode]="navigationInteractionMode"
            [iconPosition]="navigationIconPosition"
            [icon]="customNavigationIcon"
            [customTooltipText]="customNavigationTooltip"
            [customClass]="'table-text-code truncate'"
            (businessPartnerNavigate)="handleShipToNavigation($event)"
          >
          </app-business-partner-navigation>
        </div>

        <ng-template #shipToPlainHorizontal>
          <span class="table-text-code truncate">
            {{ shipToCode }}
          </span>
          <span class="truncate">
            {{ shipToName }}
          </span>
        </ng-template>
      </div>
    </div>
  </div>
</div>
